import React from "react";
import { compose } from "redux";

import draggable from "fantastic/components/hoc/draggable";
import Item from './Item';

export default compose(draggable("ITEM"))(Item);
